import React from "react";
import { Box, Container, Typography } from "@material-ui/core";

export default function AboutUs() {
  return (
    <Container maxWidth="md" style={{ paddingTop: 24, paddingBottom: 40 }}>
      <Typography variant="h4" style={{ fontWeight: 700, color: "#0F3B62" }}>
        About Us
      </Typography>
      <Box mt={2}>
        <Typography variant="body1" style={{ lineHeight: 1.8, color: "#334155" }}>
          Montestory is a thoughtfully designed digital platform built to support authentic Montessori education in modern classrooms. We aim to empower schools, educators, and parents with tools that simplify planning, tracking, and enhancing each child’s learning journey.
        </Typography>
        <Box mt={2}>
          <Typography variant="body1" style={{ lineHeight: 1.8, color: "#334155" }}>
            Rooted in the principles of the Montessori method, Montestory focuses on structured learning through clearly defined Areas of Work, Activities, and Exercises. The platform comes with preloaded Montessori-aligned content, including language materials and foundational exercises, enabling teachers to seamlessly integrate curriculum planning into their daily workflow.
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography variant="body1" style={{ lineHeight: 1.8, color: "#334155" }}>
            Montestory goes beyond simple record-keeping. It enables educators to plan individualized activities for each child, track progress based on key developmental milestones, and generate meaningful insights for better review and decision-making. Our system is designed to help teachers observe, guide, and respond to each learner’s unique pace and interests.
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography variant="body1" style={{ lineHeight: 1.8, color: "#334155" }}>
            We are continuously evolving to include comprehensive lesson plans, assignments, and refreshment resources, ensuring teachers have everything they need to create engaging and effective learning environments.
          </Typography>
        </Box>
        <Box mt={2}>
          <Typography variant="body1" style={{ lineHeight: 1.8, color: "#334155" }}>
            At Montestory, we believe that every child deserves a personalized learning path—and every educator deserves the right tools to make that possible.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}

